var _path, _mask, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAu = function SvgAu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E4E9D",
    d: "M0 0h16v12H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "au_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h10v7H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#au_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11-1.167-1 8.167",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11-1.167-1 8.167",
    stroke: "#DC251C",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1-1.167 12 9.334",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1-1.167 12 9.334",
    stroke: "#DC251C",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 0v7M0 3.5h10",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 0v7M0 3.5h10",
    stroke: "#DC251C",
    strokeWidth: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.5,
    r: 0.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 5.5,
    r: 0.5,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 4.5,
    r: 0.5,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 6.5,
    r: 0.5,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 9.5,
    r: 0.5,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 10,
    r: 1,
    fill: "#fff"
  })));
};
export default SvgAu;